__turbopack_context__.v({
  "checkIcon": "_1_GXVq_checkIcon",
});
